import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

export type UploadMarketShopProductImageRequest = {
  file: File
}

export type UploadMarketShopProductImageResponse = {
  image: string
}

export const uploadMarketShopProductImage = async (data: UploadMarketShopProductImageRequest) => {
  const formData = new FormData()
  formData.append('image', data.file)

  const response = await authAPI.post<UploadMarketShopProductImageResponse>(
    '/market-shop/product/image',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  )
  return response.data
}

export const useUploadMarketShopProductImage = () => {
  return useMutation({
    mutationFn: uploadMarketShopProductImage,
  })
}
